import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = () => {
  const badges = [
    {
      icon: 'Shield',
      title: 'Secure Payment',
      description: 'SSL encrypted transactions'
    },
    {
      icon: 'RefreshCw',
      title: '30-Day Money Back',
      description: 'Full refund guarantee'
    },
    {
      icon: 'Award',
      title: 'Certified Courses',
      description: 'Industry-recognized certificates'
    },
    {
      icon: 'Users',
      title: '50,000+ Students',
      description: 'Join our learning community'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {badges?.map((badge, index) => (
        <div 
          key={index}
          className="flex flex-col items-center text-center p-4 md:p-6 bg-card rounded-lg border border-border shadow-sm transition-base hover:shadow-md"
        >
          <div className="w-12 h-12 md:w-16 md:h-16 bg-primary/10 rounded-full flex items-center justify-center mb-3 md:mb-4">
            <Icon 
              name={badge?.icon} 
              size={24} 
              color="var(--color-primary)" 
            />
          </div>
          <h4 className="text-sm md:text-base font-heading font-bold text-foreground mb-1 md:mb-2">
            {badge?.title}
          </h4>
          <p className="text-xs md:text-sm text-muted-foreground">
            {badge?.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;